import { ChangeDetectionStrategy, Component, signal, inject, Input, computed } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IMAGE_URLS } from 'src/app/core/constants/image-source';
import { Product } from 'src/app/products/models/product.model';
import { PriceService } from 'src/app/products/services/price.service';
import { IndianCurrencyPipe } from 'src/app/shared/pipes/indian-currency.pipe';

@Component({
  standalone: true,
    selector: 'webstore-related-products-card',
    templateUrl: './related-products-card.component.html',
    styleUrls: ['./related-products-card.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        CommonModule,
        IndianCurrencyPipe
    ]
})
export class RelatedProductsCardComponent {
  private priceService = inject(PriceService);


  IMAGE_URLS = IMAGE_URLS;

  private _product = signal<Product>({} as Product);
  private _sellingPrice = signal<number>(0);
  private _actualPrice = signal<number>(0);

  @Input() set product(value: Product) {
    if (value) {
      this._product.set(value);
      const { actualPrice, sellingPrice } = this.priceService.getProductPrice(value);
      this._sellingPrice.set(sellingPrice);
      this._actualPrice.set(actualPrice);
    }
  }
  get product(): Product {
    return this._product();
  }

  readonly sellingPrice = computed(() => this._sellingPrice());
  readonly actualPrice = computed(() => this._actualPrice());
  readonly hasDiscount = computed(() => this._sellingPrice() < this._actualPrice());
  readonly hasFeaturedImages = computed(() => this._product()?.featured_images?.length > 0);
  readonly firstImageUrl = computed(() => this._product()?.featured_images?.[0]?.url || IMAGE_URLS.noImagePlaceholder);
}


